// extracted by mini-css-extract-plugin
export var menuItem = "z_t2 d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "z_t3 d_Z d_bz d_bP";
export var menuMainLink = "z_t4 d_f0 d_dB";
export var menuLink = "z_t5 d_f0 d_dB";
export var icon = "z_p9 d_bC d_bP";
export var divider = "z_t6 d_bC d_bP";
export var sublinks = "z_t7";
export var link = "z_mC";
export var Link = "z_tD y_tD y_sY y_th";